/*
 * Roy Jones: renk seçimine göre ürün galerisini filtreler.
 * Yapılandırma snippets/rj-variant-media.liquid içindeki JSON'dan gelir.
 *
 * Refresh (Dawn 16) notları:
 * - Düğme tipi seçicide input adı "Renk-1" biçimindedir, "options[Renk]" değildir;
 *   bu yüzden seçili değer ada göre değil, variant-selects içindeki işaretli
 *   input/select değerinden okunur.
 * - Galeri öğeleri data-media-id="<bölüm id>-<medya id>" taşır.
 * - product-info.js varyant değişiminde galeri listesini yeniden sıralayıp öğe
 *   ekleyebilir; MutationObserver filtreyi bu güncellemeden sonra tekrar uygular.
 */
(function () {
  if (window.rjVariantMediaLoaded) return;
  window.rjVariantMediaLoaded = true;

  const HIDDEN_CLASS = 'rj-media-hidden';
  const MEDIA_ITEM_SELECTOR = '[data-media-id]';
  const THUMBNAIL_SELECTOR = '[data-target]';

  function injectStyle() {
    const style = document.createElement('style');
    style.textContent = `.${HIDDEN_CLASS}{display:none !important;}`;
    document.head.appendChild(style);
  }

  function parseGroups(groupString, mediaIds) {
    return groupString.split('|').reduce((groups, entry) => {
      const [color, range] = entry.split(':');
      const [start, end] = range.split('-').map(Number);
      const ids = mediaIds.slice(start, end + 1).map(String);
      return ids.length ? { ...groups, [color.trim()]: ids } : groups;
    }, {});
  }

  function mediaIdOf(element, attribute) {
    const value = element.getAttribute(attribute) || '';
    return value.slice(value.lastIndexOf('-') + 1);
  }

  function selectedColor(scope, groups) {
    const selects = scope.querySelector('variant-selects');
    if (!selects) return null;
    const values = [
      ...Array.from(selects.querySelectorAll('input:checked'), (input) => input.value),
      ...Array.from(selects.querySelectorAll('select'), (select) => select.value),
    ];
    return values.find((value) => Object.prototype.hasOwnProperty.call(groups, value)) || null;
  }

  function activate(gallery, item) {
    const viewer = gallery.elements && gallery.elements.viewer;
    if (viewer) viewer.querySelectorAll(MEDIA_ITEM_SELECTOR).forEach((el) => el.classList.remove('is-active'));
    item.classList.add('is-active');
    if (item.parentElement) item.parentElement.scrollTo({ left: item.offsetLeft });

    const thumbnails = gallery.elements && gallery.elements.thumbnails;
    if (!thumbnails || typeof gallery.setActiveThumbnail !== 'function') return;
    const target = item.getAttribute('data-media-id');
    const thumbnail = thumbnails.querySelector(`[data-target="${target}"]`);
    if (thumbnail) gallery.setActiveThumbnail(thumbnail);
  }

  function resetSliders(gallery) {
    gallery.querySelectorAll('slider-component').forEach((slider) => {
      if (typeof slider.resetPages === 'function') slider.resetPages();
    });
  }

  function applyFilter(state) {
    const { scope, groups } = state;
    const gallery = scope.querySelector('media-gallery');
    if (!gallery) return;

    const color = selectedColor(scope, groups);
    const allowed = color ? groups[color] : null;
    const isAllowed = (id) => !allowed || allowed.indexOf(id) !== -1;

    const items = Array.from(gallery.querySelectorAll(`.product__media-item${MEDIA_ITEM_SELECTOR}`));
    items.forEach((item) => item.classList.toggle(HIDDEN_CLASS, !isAllowed(mediaIdOf(item, 'data-media-id'))));
    gallery.querySelectorAll(`.thumbnail-list__item${THUMBNAIL_SELECTOR}`).forEach((thumb) => {
      thumb.classList.toggle(HIDDEN_CLASS, !isAllowed(mediaIdOf(thumb, 'data-target')));
    });

    const colorChanged = color !== state.lastColor;
    state.lastColor = color;
    const active = items.find((item) => item.classList.contains('is-active'));
    const firstVisible = allowed
      ? allowed.map((id) => items.find((item) => mediaIdOf(item, 'data-media-id') === id)).find(Boolean)
      : items[0];
    const activeHidden = !active || active.classList.contains(HIDDEN_CLASS);
    if (firstVisible && (activeHidden || (colorChanged && allowed))) activate(gallery, firstVisible);

    resetSliders(gallery);
  }

  function hideOptionValues(scope, hideString) {
    if (!hideString) return;
    const values = hideString.split('|').map((value) => value.trim());
    const selects = scope.querySelector('variant-selects');
    if (!selects) return;
    selects.querySelectorAll('input[type=radio]').forEach((input) => {
      if (values.indexOf(input.value) === -1) return;
      input.classList.add(HIDDEN_CLASS);
      const label = selects.querySelector(`label[for="${input.id}"]`);
      if (label) label.classList.add(HIDDEN_CLASS);
    });
    selects.querySelectorAll('option').forEach((option) => {
      if (values.indexOf(option.value) !== -1) option.hidden = true;
    });
  }

  function init(configElement) {
    const config = JSON.parse(configElement.textContent);
    const scope =
      configElement.closest('product-info') ||
      document.querySelector(`product-info[data-section="${config.section}"]`) ||
      document;
    const groups = config.gruplar
      ? Object.fromEntries(Object.entries(config.gruplar).map(([renk, idler]) => [renk, idler.map(String)]))
      : parseGroups(config.groups, config.media);
    const state = { scope, groups, lastColor: undefined, scheduled: false };
    const gizlenecek = Array.isArray(config.gizle) ? config.gizle.join('|') : config.hide;
    const hideValues = () => hideOptionValues(scope, gizlenecek);

    const schedule = () => {
      if (state.scheduled) return;
      state.scheduled = true;
      window.requestAnimationFrame(() => {
        state.scheduled = false;
        hideValues();
        applyFilter(state);
      });
    };

    scope.addEventListener('change', (event) => {
      if (event.target.closest && event.target.closest('variant-selects')) schedule();
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, schedule);
    }
    // Yalnızca galeri listelerinin doğrudan çocukları izlenir: slider sayaçları gibi
    // metin güncellemeleri (resetPages) gözlemciyi yeniden tetikleyip döngü kurmasın.
    const gallery = scope.querySelector('media-gallery');
    if (gallery) {
      const observer = new MutationObserver(schedule);
      gallery.querySelectorAll('ul').forEach((list) => {
        if (list.querySelector(`:scope > ${MEDIA_ITEM_SELECTOR}, :scope > ${THUMBNAIL_SELECTOR}`)) {
          observer.observe(list, { childList: true });
        }
      });
    }

    hideValues();
    applyFilter(state);
  }

  function boot() {
    injectStyle();
    document.querySelectorAll('script[data-rj-variant-media]').forEach((element) => {
      try {
        init(element);
      } catch (error) {
        console.error('[rj-variant-media] başlatılamadı', error);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
